import {
    FETCH_PICK_LIST_PENDING,
    FETCH_PICK_LIST_SUCCESS,
    FETCH_PICK_LIST_FAILED,
    PICK_SCAN_RESULT,
    PICK_SESSION_STARTED,
    PICK_SESSION_STATUS,
    CLEAR_PICK_SCAN_RESULT
} from "../types";

const initialState = {
    pickListItems: [],
    pickListStatus: '',
    pickSession: null,
    lastScanResult: null,
    sessionStatus: null,
};

const PickValidationReducer = (state = initialState, action = '') => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_PICK_LIST_PENDING:
            return {
                ...state,
                pickListStatus: 'PENDING',
                pickListItems: [],
            };
        case FETCH_PICK_LIST_SUCCESS:
            return {
                ...state,
                pickListStatus: 'SUCCESS',
                pickListItems: payload.pickListItems,
            };
        case FETCH_PICK_LIST_FAILED:
            return {
                ...state,
                pickListStatus: 'FAILED',
                pickListItems: [],
            };
        case PICK_SESSION_STARTED:
            return {
                ...state,
                pickSession: payload,
            };
        case PICK_SCAN_RESULT:
            return {
                ...state,
                lastScanResult: payload,
            };
        case PICK_SESSION_STATUS:
            return {
                ...state,
                sessionStatus: payload,
            };
        case CLEAR_PICK_SCAN_RESULT:
            return {
                ...state,
                lastScanResult: null,
            };
        default:
            return state;
    }
};

export default PickValidationReducer;
